/* src/app/shared/components/flow-loader/flow-loader.component.scss */
:host {
  display: contents;
}
.flow-loader {
  border-radius: 50%;
  border-style: solid;
  border-bottom-color: transparent !important;
  animation: flow-loader-spin 0.7s linear infinite;
}
.flow-loader.light {
  border-color: #ffffff;
}
.flow-loader.dark {
  border-color: #18181b;
}
.flow-loader.accent {
  border-color: #3753be;
}
.flow-loader.small {
  width: 16px;
  height: 16px;
  border-width: 1px;
}
.flow-loader.medium {
  width: 20px;
  height: 20px;
  border-width: 1px;
}
.flow-loader.large {
  width: 28px;
  height: 28px;
  border-width: 1px;
}
@keyframes flow-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=flow-loader.component.css.map */
